// extracted by mini-css-extract-plugin
export default {"header":"NavBar_header__wrgBx","logo":"NavBar_logo__7bh5z","title":"NavBar_title__fDxn0"};